import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ToastMessage from "../ferramentas/toastMessage/ToastMessage";
import style from "./PasswordChange.module.css"; // MELHORIA: Caminho atualizado para o novo CSS module
import { useDataManagement } from "../ferramentas/RequisitarAPI.ts";
import Placeholder from "../ferramentas/placeholder/Placeholder.js";

function PasswordChange() {
    const [email, setEmail] = useState(""); // MELHORIA: Inicializar com string vazia
    const [isLoading, setIsLoading] = useState(false); // MELHORIA: Adiciona estado de loading
    const navigate = useNavigate();
    const { users: { changePassword } } = useDataManagement();
      
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email) {
            ToastMessage({ cod: "w", texto: "Por favor, preencha o campo de email." });
            return;
        }

        setIsLoading(true); // Inicia o loading
    
        try {
            const response = await changePassword({ email });    
            
            // MELHORIA: Tratamento de erro mais robusto
            if (response.ok) {
                ToastMessage({ cod: "s", texto: "Se o email existir em nossa base, uma nova senha será enviada." });
                // MELHORIA: Um delay um pouco maior para o usuário ler o toast
                setTimeout(() => {                        
                    navigate("/login");
                }, 2000); 
            } else {
                const errorMessage = response?.message || "Ocorreu um erro ao tentar redefinir a senha.";
                throw new Error(errorMessage);
            }
        } catch (error) {
            ToastMessage({ cod: "e", texto: error.message});
        } finally {
            setIsLoading(false); // Finaliza o loading, independente do resultado
        }
    };
    
    return (
        // NOVO: Container para centralizar o card na página
        <div className={style.pageContainer}> 
            <div className={style.passwordCard}>
                <h2>Redefinir Senha</h2>
                
                {/* NOVO: Parágrafo instrutivo para melhorar a UX */}
                <p className={style.instructions}>
                    Digite seu e-mail abaixo. Enviaremos um link de confirmação.
                </p>

                <form onSubmit={handleSubmit} noValidate>
                   <Placeholder  
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                   />             
                   
                    {/* NOVO: Agrupamento de botões para melhor layout */}
                    <div className={style.buttonGroup}>
                        {/* CORREÇÃO: type="button" previne o envio do formulário */}
                        <button 
                            type="button" 
                            className={`${style.btn} ${style.btnSecondary}`} 
                            onClick={() => navigate("/login")}
                            disabled={isLoading} // Desabilita durante o loading
                        >
                            Voltar
                        </button>

                        <button 
                            type="submit" 
                            className={`${style.btn} ${style.btnPrimary}`}
                            disabled={isLoading} // Desabilita durante o loading
                        >
                            {isLoading ? "Enviando..." : "Confirmar"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default PasswordChange;